import Vue from 'vue'
import axios from 'axios'

const errorMap = new Map()

// Axios.defaults.baseURL = process.env.APP_API_URL
// Axios.defaults.headers.common.Accept = 'application/json'
const axiosInstance = axios.create({
  withCredentials: true
})

function buildKey (config) {
  return `${config.method} ${config.url}`
}

axiosInstance.interceptors.request.use(function (config) {
  errorMap.delete(buildKey(config))
  return config
}, function (error) {
  errorMap.set(buildKey(error.config), error)
  return Promise.reject(error)
})
axiosInstance.interceptors.response.use(function (config) {
  errorMap.delete(buildKey(config))
  return config
}, function (error) {
  errorMap.set(buildKey(error.config), error)
  return Promise.reject(error)
})

Vue.$http = axiosInstance
Object.defineProperty(Vue.prototype, '$http', {
  get () {
    return axiosInstance
  }
})

export default axios



// WEBPACK FOOTER //
// ./src/plugins/axios.js